import api from "../api";

const API_CHART = `${api.api}/chart`;

const chartApi = {
  chart: API_CHART
};

export default chartApi;
